export default {
    new: "START",
    requested: "REQUEST",
    awaiting: 'WAITENVELOPE',
    formed: "RESPONSE",
    ready: "READY",
    prepared_to_registry: "PREREESTR",
    in_registry: "INREESTR",
    error: "RESPONSE_ERROR",
    communication_error: "COMMUNICATION_ERROR",
}

//     START - Новый
//     REQUEST - Был отправлен запрос на формирование уведомления, конверта и бар-кода
//     WAITENVELOPE - Ожидание ответа от сервиса почты / окончание формирования конверта
//     RESPONSE - Конверт, уведомление и бар-код сформированы
//     READY - Список документов готов и передан в список для формирования реестра
//     PREREESTR - Список документов отмечен для передачи в реестр
//     INREESTR - Документы добавлены в реестр
//     RESPONSE_ERROR - Ошибка формирования конверта